module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "aubio"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("Garrett Stewart is the James O. Freedman Professor of Letters in the Department of English at the University of Iowa and the author of numerous books on fiction and film.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2015 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. Published 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("24 23 22 21 20 19 18 17 16 15  1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("ISBN-13: 978-0-226-20121-4 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-20149-8 (paper)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-20135-1 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("DOI: 10.7208/chicago/9780226201351.001.0001")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Stewart, Garrett, author.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Closed circuits : screening narrative surveillance / Garrett Stewart.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("pages ; cm")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-226-20121-4 (cloth : alk. paper)— "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-226-20149-8 (pbk. : alk. paper)—")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-226-20135-1 (ebook) 1. Electronic surveillance in motion pictures.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("2. Motion pictures—United States—History and criticism. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("PN1995.9.E38S74 2015")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("791.430973—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("2014016861")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("♾ This paper meets the requirements of ANSI"), _c('span', {
    staticClass: "sm"
  }, [_vm._v("/")]), _vm._v("NISO Z39.48–1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-198c3310","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-stewart-0004.vue
// module id = 63
// module chunks = 0